import React from 'react'
import styled from '@emotion/styled'
import tw from 'twin.macro'
import dayjs from 'dayjs'
import quarterOfYear from 'dayjs/plugin/quarterOfYear'
import Block from '../components/block'
import Pie from '../components/pie'
import Bar from '../components/bar'
import Rose from '../components/rose'
import Article from '../components/article'
import List from '../components/list'
import Circle from '../components/circle'
import Progress from '../components/progress'
import { OSSURL } from '../constant'

dayjs.extend(quarterOfYear)

const Content = styled.div`
  width: 100%;
  ${tw`flex flex-col gap-1 flex-1`}
  .title {
    background: url(${OSSURL}/content_title_bg.png) no-repeat;
    height: 35px;
    background-size: 100% 100%;
    ${tw`flex items-center pl-4`}
    div {
      background-image: linear-gradient(to bottom, #fff 20%, #9cd2ff 85%);
      background-clip: text;
      font-family: YouSheBiaoTiHei;
      font-size: 18px;
      color: transparent;
      font-style: italic;
      ${tw`font-bold`}
    }
  }
  .content {
    ${tw`h-full w-full`}
  }
  .contentWithBg {
    background: url(${OSSURL}/content_bg.png) no-repeat;
    background-size: 100% 100%;
    ${tw`h-full p-1 w-full overflow-y-auto`}
  }
`

const Item = function ({ configData, time }) {
  return (
    <div
      style={{ width: '25%', pointerEvents: 'auto' }}
      className="h-full flex flex-col gap-4 w-full"
    >
      {configData
        .filter((config) => {
          return config.type !== 'map'
        })
        .map((d) => {
          return (
            <Content key={d.type}>
              <div className="title">
                <div>{d.title}</div>
              </div>
              <div className="flex flex-1 overflow-y-auto">
                {d.type === 'circle' && (
                  <div className="contentWithBg">
                    <Circle data={d} customDsl={time} />
                  </div>
                )}
                {d.type === 'block' && (
                  <div className="content">
                    <Block data={d} customDsl={time} />
                  </div>
                )}
                {d.type === 'pie' && (
                  <div className="contentWithBg">
                    <Pie data={d} customDsl={time} />
                  </div>
                )}
                {d.type === 'bar' && (
                  <div className="contentWithBg">
                    <Bar data={d} customDsl={time} />
                  </div>
                )}
                {d.type === 'rose' && (
                  <div className="contentWithBg">
                    <Rose data={d} customDsl={time} />
                  </div>
                )}
                {d.type === 'article' && (
                  <div className="content">
                    <Article />
                  </div>
                )}
                {d.type === 'list' && (
                  <div className="content">
                    <List data={d} customDsl={time} />
                  </div>
                )}
                {d.type === 'progress' && (
                  <div className="contentWithBg">
                    <Progress data={d} customDsl={time} />
                  </div>
                )}
              </div>
            </Content>
          )
        })}
    </div>
  )
}

export default Item
